import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { planCan } from "@/lib/plans";
import { toast } from "sonner";
import { useEffect, useRef } from "react";

/**
 * Protege rutas gateadas por plan.
 * Si el plan del usuario no incluye la feature, redirige al dashboard
 * y muestra un toast informativo.
 *
 * Uso: <PlanGate feature="cotizaciones"><QuotesPage /></PlanGate>
 */
export default function PlanGate({ feature, children }) {
  const { user, loading } = useAuth();
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (!loading && user && !planCan(user.plan, feature) && !notifiedRef.current) {
      notifiedRef.current = true;
      const featureLabel = feature === "cotizaciones" ? "Cotizaciones" : feature === "comprobantes" ? "Comprobantes" : feature;
      toast.info(
        `El módulo de ${featureLabel} está disponible en los planes Pro y Enterprise. Tu plan actual es ${user.plan}.`
      );
    }
  }, [loading, user, feature]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!planCan(user.plan, feature)) return <Navigate to="/" replace />;
  return children;
}
